export default (keys: string | string[], callback: () => void, modifiers: string[][] = [['metaKey'], ['ctrlKey']]) => {
    if (!Array.isArray(keys)) {
        keys = [keys];
    }

    const listenerCallback = (e: KeyboardEvent) => {
        if (!modifiers.some((group) => group.every((modifier) => e[modifier as keyof KeyboardEvent]))) {
            return;
        }

        if (keys.includes(e.key)) {
            e.preventDefault();
            callback();
        }
    };

    onBeforeMount(() => {
        // console.log('Global shortcut added', {keys, modifiers});
        window.addEventListener('keydown', listenerCallback);
    });

    onBeforeUnmount(() => {
        // console.log('Global shortcut removed', {keys, modifiers});
        window.removeEventListener('keydown', listenerCallback);
    });
};
